import React, { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { TableSort } from 'components/WrappedComponents/Table/types';
import GFFilterProvider from 'hooks/GFFilterStoreContext';
import PaginationProvider, {
  DictTablePagination,
  PAGINATION_DICT_DEFAULT,
} from 'hooks/PaginationStoreContext';
import SortProvider from 'hooks/SortStoreContext';
import { useActionsRequises } from 'hooks/useActionsRequises';
import { FilterDashboardGardien } from 'pages/gardien-fourriere/Dashboard/DashboardHeader/Filters/types';
import { NOT_FOUND_PATH } from 'utils/enumData';

import PageComptes from './Comptes/PageComptes';
import { GardienSortOptions } from './Dashboard/DashboardTable/types';
import Details from './Dossier/Details/Details';
import DashBoard from './Dashboard';

const GfRouter: React.FC = () => {
  const [pagination, setPagination] = useState<DictTablePagination>(
    PAGINATION_DICT_DEFAULT,
  );
  const [filter, setFilter] = useState<Partial<FilterDashboardGardien>>({});
  const [sort, setSort] = useState<
    Partial<TableSort<GardienSortOptions | undefined>>
  >({
    IMMATRICULATION: true,
  });

  const gfActionsRequises = useActionsRequises();

  return (
    <PaginationProvider
      value={{ pagination: pagination, setPagination: setPagination }}
    >
      <GFFilterProvider
        value={{
          filter: filter,
          setFilter: setFilter,
          actionsRequises: gfActionsRequises,
        }}
      >
        <SortProvider value={{ sort: sort, setSort: setSort }}>
          <Routes>
            <Route path="" element={<DashBoard />} />
            <Route path="dossier/:id" element={<Details />} />
            <Route
              path="*"
              element={<Navigate replace to={NOT_FOUND_PATH} />}
            />
            <Route path="comptes" element={<PageComptes />} />
          </Routes>
        </SortProvider>
      </GFFilterProvider>
    </PaginationProvider>
  );
};

export default GfRouter;
